@for (item of actions; track item) {
  @if (checkIsVisible(item) === true) {
    <button
      [attr.data-test-name]="item.identifier"
      [disabled]="checkIsLoading(item) || checkDisabled(item)"
      mat-raised-button
      [color]="item.color"
      type="submit"
      (click)="itemClick(item)"
      ngStyle.xs="margin-bottom: 12px; min-width: 150px"
    >
      <div class="flex gap-3">
        <div class="flex-grow flex-shrink-0 basis-auto">
          {{ item.displayName }}
        </div>
        @if (checkIsLoading(item)) {
          <div class="flex-grow-0 flex-shrink basis-auto" style="padding-top: 8px">
            <mat-spinner [diameter]="20"></mat-spinner>
          </div>
        }
      </div>
    </button>
  }
}
